var _linearGradient, _clipPath, _clipPath2, _clipPath3, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMockupAdBottles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 390 763",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(0 763 -763 0 195 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bddce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9ccdde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#55adc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118eb0"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m390 19.5c0-10.762-8.738-19.5-19.5-19.5h-351c-10.762 0-19.5 8.738-19.5 19.5v724c0 10.762 8.738 19.5 19.5 19.5h351c10.762 0 19.5-8.738 19.5-19.5z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m382 57.333c0-2.943-2.39-5.333-5.333-5.333h-363.334c-2.943 0-5.333 2.39-5.333 5.333v259c0 2.944 2.39 5.334 5.333 5.334h363.334c2.943 0 5.333-2.39 5.333-5.334z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m382 57.333c0-2.943-2.39-5.333-5.333-5.333h-363.334c-2.943 0-5.333 2.39-5.333 5.333v259c0 2.944 2.39 5.334 5.333 5.334h363.334c2.943 0 5.333-2.39 5.333-5.334z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m390 19.5c0-10.762-8.738-19.5-19.5-19.5h-351c-10.762 0-19.5 8.738-19.5 19.5v724c0 10.762 8.738 19.5 19.5 19.5h351c10.762 0 19.5-8.738 19.5-19.5z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h390v44h-390z",
    fill: "#fff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 714h390v49h-390z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.467,
    cy: 738.5,
    r: 12.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.733,
    cy: 738.5,
    r: 12.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 738.5,
    r: 12.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269.267,
    cy: 738.5,
    fillOpacity: 0.5,
    r: 12.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.533,
    cy: 738.5,
    fillOpacity: 0.1,
    r: 12.25
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m382 57.333c0-2.943-2.39-5.333-5.333-5.333h-363.334c-2.943 0-5.333 2.39-5.333 5.333v259c0 2.944 2.39 5.334 5.333 5.334h363.334c2.943 0 5.333-2.39 5.333-5.334z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 92h159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 155.222h159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 281.667h159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 218.444h159"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockupAdBottles);
export default __webpack_public_path__ + "static/media/mockup-ad-bottles.19d7e046885c25853a9aafc235c3d646.svg";
export { ForwardRef as ReactComponent };